const tableHeaders = [
  {
    label: 'Submitted',
    key: 'submitted',
    sortable: false,
  },
  {
    label: 'Approved/Switched',
    key: 'approved',
    sortable: false,
  },
  {
    label: 'Denied',
    key: 'denied',
    sortable: false,
  },
  {
    label: 'Open',
    key: 'open',
    sortable: false,
  },
];

export default () => tableHeaders;
